/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Zns_Message_Not_SentInputs */

const vi_error_zns_message_not_sent = /** @type {(inputs: Error_Zns_Message_Not_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tin chưa được Zalo nhận nên chưa kiểm tra trạng thái được.`)
};

/**

* @param {Error_Zns_Message_Not_SentInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_zns_message_not_sent = /** @type {((inputs?: Error_Zns_Message_Not_SentInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Zns_Message_Not_SentInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_zns_message_not_sent(inputs)
});